import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { ToggleService } from '../../services/toggle.service';
import { CustomerService } from '../../services/customer.service';
import { UsersService } from '../../services/users.service';
import { CryptoService } from '../../services/crypto.service';
import { StorageService } from 'src/app/services/storageService.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
})
export class AppMenuComponent implements OnInit {

  public role = "";
  public avAppPages = [
    {
      title: 'Dashboard',
      url: '/home',

      role: 'au,ad'
    },
    {
      title: 'Projects',
      url: '/projects',

      role: 'au,ad'
    },
    {
      title: 'Learning Objectives',
      url: '/outcomes',

      role: 'au,ad'
    },
    {
      title: 'Media',
      url: '/media-management',

      role: 'au,ad,sa'
    },
    /*{
      title: 'Robotics',
      url: '/robotics',

      role: 'au,ad,sa'
    },
    {
      title: 'Recorded Assessments',
      url: '/recorded-assessments',

      role: 'au,ad,sa'
    },
    {
      title: 'Observable Assessments',
      url: '/observable-assessments',

      role: 'au,ad,sa'
    },
    {
      title: 'Live Feeds',
      url: '/live-feeds',

      role: 'au,ad,sa'
    },*/
    {
      title: 'Daily Report',
      url: '/daily-report',

      role: 'ad'
    }, {
      title: 'Learners',
      url: '/learners',

      role: 'au,ad'
    },
    {
      title: 'Admins & Authors',
      url: '/admins-authors',

      role: 'ad'
    },
    {
      title: 'Customers',
      url: '/customers',

      role: 'sa'
    },
    {
      title: 'My Account',
      url: '/my-account',

      role: 'sa,ad'
    },
    {
      title: 'My Orders',
      url: '/my-orders',
 
      role: 'ad'
    },
    {
      title: 'My Profile',
      url: '/my-profile',

      role: 'sa,ad,au'
    },
    {
      title: 'Help',
      url: '/help',

      role: 'sa,ad,au'
    }
  ];
  public appPages = []

  constructor(
    public toggleService: ToggleService,
    public authService: AuthenticationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public customerService: CustomerService,
    public userService: UsersService,
    public cryptoService: CryptoService,
    public storageService: StorageService
  ) { 
  }

  ngOnInit() {
    setInterval(() => {
      this.role = this.cryptoService.decryptData(this.storageService.getItem("login_r"));
      this.appPages = this.avAppPages.filter(x => x.role.indexOf(this.role) >= 0);
    }, 2000);
  }

  logOut() {
    this.authService.logOut();
  }

  myProfile() {
    this.userService.presentUpsertProfile(this.cryptoService.decryptData(this.storageService.getItem("login_email")));
  }

}
